import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { Breadcrumb } from './breadcrumbs';

@Component({
  selector: 'gax-breadcrumbs',
  styleUrls: ['./breadcrumbs.component.scss'],
  templateUrl: './breadcrumbs.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BreadcrumbsComponent {
  @Input() breadcrumbs: Breadcrumb[] | null = [];
  @Input() backButton = false;
}
